import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import DestinationWidgetService from "../../../services/KangarooServices/Intelligence/DestinationWidgetService";
import toast from "react-hot-toast";
import DestinationWidgetForm from "../component/DestinationWidgetForm";

const DestinationWidget = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const toggleWidget = (item) => {
    setSelectedItem(item)
    setIsWidgetOpen(!isWidgetOpen);
  };
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  const toggleAssignModal = (item) => {
    setSelectedItem(item);
    setIsAssignModalOpen(!isAssignModalOpen);
  };
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await DestinationWidgetService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await DestinationWidgetService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Channel Partners" pageTitle="KEF Intelligence" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button className="btn btn-success" onClick={toggleWidget}>
              <i className="bi bi-plus-lg"></i> New Widget
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="3" className="g-4">
          {data?.map((item, index) => {
            return (
              <Col key={item.id}>
                <Card>
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <CardImg
                      top
                      src={`${imageBaseApi}${item?.widgetImageUrl}`}
                      alt={item.fileName}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <CardBody>
                    <p>{item?.destinationCountryName}</p>
                    <p className="text-muted ">{item?.widgetName}</p>
                   
                  </CardBody>
                  <CardFooter>
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => toggleWidget(item)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            );
          })}
        </Row>
        <DestinationWidgetForm
          isOpen={isWidgetOpen}
          toggle={toggleWidget}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default DestinationWidget;
